import { useQueryClient } from 'react-query'
import { StreakMapResponse } from '../types'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { transformStreaks } from '../utils'

export const useChartData = () => {
  const [year, userId] = useStats((s) => [s.year, s.statsUserId])
  const queryKey = ['stats-streaks-map', userId, year]
  const client = useQueryClient()
  const data = client.getQueryData<StreakMapResponse>(queryKey)
  const results = data?.data || []

  return { data: transformStreaks(results) }
}
